
export function getTableWidth(classname){
  let table = document.querySelector(`.${classname} .u-table-scroll .u-table-body`);
  let width =table ? table.getBoundingClientRect().width : undefined;
  return width
}